import commonEn from './locales/en/common'
import homeEn from './locales/en/home'
import consultEn from './locales/en/consult'
import aboutEn from './locales/en/about'
import legalEn from './locales/en/legal'

export const langEn = {
    product: "Assessment",
    training: "Training",
    mation: "News",
    onlineScoring: "Scoring Online",
    about: "About",
    headerMainSystem: "Exam System",
    headerScoringService: "Scoring Service",
    headerLangZh: "中文",
    headerLangEn: "English",
    headerMenuHome: "Home",
    headerMenuTrain: "Training",
    headerMenuProduct: "Scales",
    headerMenuConsult: "Consulting",
    headerMenuNews: "News",
    headerMenuAbout: "About Us",
    headerMenuAboutYulin: "About Yulin",
    homeHeroTitle: "Committed to standardized screening, diagnosis and assessment scales.",
    homeHeroDesc: "We are currently serving about 1,000 doctors, therapists, special educators, social workers and related professionals.",
    homeHeroPrimaryCta: "View Scales",
    homeHeroSecondaryCta: "Enter Exam System",
    homeProductTitle: "Assessment Scales",
    homeProductTagline: "Assessment Scales",
    homeProductDesc: "We provide professional scales for neurodevelopment, adaptive behavior, motor development and learning difficulties, covering the full life cycle from infancy to old age.",
    homeProductFallbackSummary: "Childhood Autism Rating Scale, Second Edition",
    homeTrainingTitle: "New Technology · Training Courses",
    homeTrainingTagline: "New Technology · Training Courses",
    homeTrainingDesc: "We continuously deliver high-value, high-frequency training courses led by experts.",
    homeExpertTitle: "R&D Team",
    homeExpertTagline: "Authority in the Field · R&D Think Tank",
    homeExpertDesc: "Our authoritative R&D team is composed of professors from psychology, medicine and education.",
    homeNewsTitle: "Latest Updates",
    homeNewsHeading: "News",
    homeNewsDesc: "Company news and industry updates are continuously published.",
    homeViewDetail: "View Details",
    homeViewMore: "View More",
    homeViewMoreEllipsis: "More...",
    homeViewMoreNews: "Go to News Center",
    homeNewsCompany: "Company News",
    homeNewsIndustry: "Industry News",
    newsCenterIntro: "Grounded in Chinese normative research and connected with global universities, medical institutions, and research organizations, HSYL develops professional and localized psychological assessment tools and integrated solutions for clinical rehabilitation, talent development, individual potential growth, and mental health advancement.",
    newsCenterEmpty: "No news available",
    newsCenterHeroAlt: "News center illustration",
    newsCenterReadMore: "View details",
    homeEmptyProduct: "No scale data",
    homeEmptyTraining: "No training data",
    homeEmptyExpert: "No expert data",
    homeEmptyNews: "No news data",
    homeStatusPending: "Pending",
    homeStatusRunning: "Running",
    homeStatusEnded: "Ended",
    footerGroupAbout: "About",
    footerGroupLatest: "Latest",
    footerGroupCompany: "HSYL",
    footerGroupService: "Products & Services",
    footerGroupLaw: "Legal",
    footerGroupContact: "Contact",
    footerAboutUs: "About Us",
    footerMenuConsult: "Consulting",
    footerLatestNews: "Latest Updates",
    footerContactUs: "Contact Us",
    footerPhone: "Phone",
    footerEmail: "Email",
    footerWechat: "WeChat Official Account",
    footerOfficialWechat: "HSYL Official WeChat",
    footerWechatId: "WeChat ID: hsyl-tech",
    footerEducationSupport: "Education Support Program",
    footerServiceScale: "Assessment Scales",
    footerServiceTraining: "Training Courses",
    footerServiceScoring: "Scoring System",
    footerLawTerms: "Terms of Use",
    footerLawEthics: "Compliance & Ethics",
    footerLawIP: "Copyright Statement",
    footerLawPrivacy: "Personal Information Protection Policy",
    footerLawSecurity: "Information Protection",
    consultTitle: "Consulting Center",
    consultDesc: "The consulting center channel is being prepared. Please check training courses and the about page for support information.",
    consultActionTraining: "View Training",
    consultActionContact: "Contact Us",
    news: "Company News",
    industry: "Industry information",
    introduction: "Company",
    team: "R&D Think Tank",
    intellectual: "Copyright Statement",
    certificate: "Patent certificate",
    authorization: "Authorization Letter",
    computer: "Computer Software Copyright Level Certificate",
    service: "产品服务",
    service1: "Tests and scales",
    service2: "Training Course ",
    privacy: "Privacy and Confidentiality Statement",
    rights: "Copyright Statement",
    disclaimers: "Exemption Statement",
    business: "经营许可证编号",
    link: "Contact us",
    cooperation: "Sino foreign cooperation",
    cooperationDesc: "本公司致力于与国内外专家合作，努力将国外高水平心理测量技术和服务技术引进中国，并且立足于国内研究，与专家合作开发适用于本土文化的测量技术和产品。同时，本公司也提供相关资质培训，帮助更多的心理测评从业者提升专业技能和水平。",
    experience: "专业经验",
    experienceDesc: "本公司的管理层和骨干成员都已在本行业耕耘十几年，对于心理测量技术和服务有着深入的研究和理解，能够为客户提供最适合的方案和服务。他们的经验和专业水平，是本公司最宝贵的财富，也是客户最可靠的保证。",
    support: "专家支持",
    supportDesc: "本公司的技术团队由一群心理学、教育学、计算机等领域的专家和学者组成，具有丰富的学术背景和研究与实践经验。热爱心理学应用和服务事业，立志为中国正在为帮助有需要的儿童青少年和他们的家庭而工作的专业技术人员，提供优质的工具和有效的帮助。本公司全体成员，希望通过我们的努力，助力我国专业技术人员能为有需要的儿童青少年以及家庭提供更好的服务。",
    achievements: "成果成就",
    achievementsDesc: "华晟育林公司将为教育、临床等应用领域提供优质的、与国际接轨的测量和服务技术。中国在许多前沿科技领域已经取得了傲人的成就，但是在心理测量技术以及应用服务方面的发展还任重道远，需要砥砺前行。本公司全体成员将竭尽全力，与国内外更多专家学者联手合作，为提升国内的测量技术做出我们自己的贡献。",
    goal: "目标愿景",
    goalDesc: "“团结、诚信、严谨、快乐”是我们的工作风格；脚踏实地做好工作，为社会贡献力量，是我们的共同目标。",
    all: "Whole",
    other: "其他信息",
    identification: "用户识别信息",
    identificationDesc: "当用户使用邮箱（手机号码）及密码通过验证成为产品的注册用户后，该手机号码（邮箱）和密码即成为用户使用本公司产品或服务的识别凭证，用户本人须对所有使用该识别凭证在本公司各产品或服务中所采取的一切行为负责。本公司建议用户不要向任何第三方披露自己的密码。如果泄漏密码，用户可能丢失个人识别信息及保存在本公司服务器上的资料。因此，请妥善保管登录手机号（邮箱）和密码。由于用户自己的原因导致用户识别信息泄露或丢失时，本公司对此和由此将引发得一切后果都不承担责任。",
    collected: "本公司收集的",
    collectedDesc: "本公司收集的资料可能包括用户来自何路径（不论该路径是否在本公司网站或软件）、用户的浏览器向本公司网站发送的资料，以及用户的 IP 地址。在用户向本公司提交反馈时，用户可以自主决定是否填写联系方式，该联系方式类型不限，可能被用于旨在了解或解决用户提交的问题的回访或反馈。",
    data: "资料",
    companyInfo: "本公司用户资料",
    companyInfoDesc: "本公司不向任何第三方展示、出售或出租任何用户个人资料。本公司可能使用用户提供的资料与用户联络并向用户传递信息，例如产品服务方面的通知、最新产品等。",
    use: "的使用和保管",
    security: "安全性",
    securityDesc: "用户资料存储于本公司的服务器中。用户资料安全是本公司信誉的基础，本公司采用行业标准尽力维护用户个人资料的隐私性，如果您对我们的个人信息保护有任何疑问，请联系我们。本公司有权根据国家法律/行业规范/自身发展等需要随时修改此隐私保护策略。",
    company: "华晟育林",
    companyDesc: "「华晟育林」一词及各个华晟育林标志均为华晟育林的商标。所采用的商标及标志均属广东省华晟育林科技有限公司（以下简称：华晟育林）的财产。网站上出现的其他名字可能属于有关其他拥有人的商标。本网站所提到或使用的产品、技术或程式的权利可能是由华晟育林或其他第叁者所保留，并无于此就该等知识产权提供任何许可。任何使用本网站人士不得在未有华晟育林的书面许可的情况下分发、修改、传送或使用本网站的任何内容作公众或商业用途。",
    content1: "本网站所载的一切资料仅供参考之用。虽然在拟备该等资料时已尽量确保其准确性，在法例允许的范围内，广东省华晟育林科技有限公司（以下简称：华晟育林）并不保证该等资料的准确性、完整性或时效性，亦不会就任何该等资料所引致或依赖该等资料而引致的后果承担任何责任。华晟育林保留随时修改本网站资料的权利，而毋须预先作出任何通知。",
    content2: "本网站中的资料的提供并不包括任何暗示或明示的保证（包括但不限于任何就其可用性、质量、对其用途的适切性或任何非违反的任何保证）；华晟育林亦无就本网站的运作的持续性、是否会受到任何干扰、电脑病毒或其他问题的侵入提出任何保证。",
    content3: "本网站可能包含第叁者网站的连结，目的仅为方便浏览人士，并不明示或暗示华晟育林对该等第叁者或其产品或服务的确认、批准、建议或偏好。华晟育林并无参与发展该等网站亦对该等网站无任何制作权或其他控制权。华晟育林就该等第叁者网站上所载的资料的内容或准确性不负任何责任。任何人士使用或接达该第叁者网站或其产品或服务，风险概由有关人士自行承担。华晟育林就任何资料透过本网站向任何第叁方的转送或提供的安全性不作出任何保证，亦不会就任何使用者从本网站接达其他网站或与其他网站的交流而引致的后果承担任何责任。",
    personalAchievements: "个人成就",
    findings: "研究成果",
    time: "Release time",
    speaker: "Presenter(s)",
    form: "Format",
    online: "Online",
    offline: "In-person",
    notStart: 'Not Started',
    starting: 'In Progress',
    ended: 'Completed',
    pilotTraining: "Training",
    trainingFormat: "Training Format",
    trainingTime: "Dates & Times",
    trainingLocation: "Location",
    download: "Download",
    ourService: "",
    onlineJudge: "Assessment",
    proTitle: "Helps to identify children with autism and determine symptom severity through quantifiable ratings based on direct observation",
    proDesc1: "Childhood Autism Rating Scale™, Second Edition",
    proDesc2: "是用于孤独症临床诊断的评估量表，在国际上享有盛名，并且在许多国家广泛应用",
    proDesc3: "标准版：小于6岁；或大于6岁，且IQ≤79；或有严重沟通障碍",
    proDesc4: "高功能版：大于6岁；并且IQ≥80；并且能流畅沟通",
    newScale: "新量表",
    developing: "正在研发",
    secondEdition: "CARS™2",
    short: "BENEFIT",
    revisionHost: "TRANSLATION",
    age: "SCORES",
    name: "Available in Bulgarian & Italian",
    above: "Cutoff scores, standard scores, and percentiles",
    publicationTime: "ADMIN TIME",
    date: "5–10 minutes (after the information needed to make the ratings has been collected)",
    format: "FORMAT",
    formatDesc: "Two 15-item rating scales completed by the clinician (each designed for a different population); and an unscored Parent/Caregiver Questionnaire",
    content4: "The Childhood Autism Rating Scale–Second Edition (CARS2) is a 15-item rating scale used to identify children with autism and distinguishing them from those with developmental disabilities. It is empirically validated and provides concise, objective, and quantifiable ratings based on direct behavioral observation. It was normed on a sample of 1,034 individuals with autism spectrum disorders.",
    content5: "This second edition of CARS expands the test’s clinical value, making it more responsive to individuals on the “high functioning” end of autism spectrum disorders. The clinician rates the individual on each item, using a 4-point rating scale. Ratings are based on frequency of the behavior in question, its intensity, peculiarity, and duration.",
    content6: "Physicians, special educators, school psychologists, speech pathologists, and audiologists will all find the CARS-2 easy to give and score.",
    applicableScope: "",
    scopeDesc1: "The CARS-2 includes three forms:",
    scopeDesc2: "1. Standard Version Rating Booklet (CARS2-ST): Equivalent to the original CARS; for use with individuals younger than 6 years of age and those with communication difficulties or below-average estimated IQs",
    scopeDesc3: "",
    scopeDesc4: "2. High-Functioning Version Rating Booklet (CARS2-HF): An alternative for assessing verbally fluent individuals, 6 years of age and older, with IQ scores above 80",
    scopeDesc5: "3. Questionnaire for Parents or Caregivers (CARS2-QPC): An unscored scale that gathers information for use in making CARS2ST and CARS2-HF ratings",
    evaluationMethod: "",
    methodDesc: "The standard and high-functioning forms each include 15 items addressing the following functional areas:",
    methodDesc1: "• Relating to People",
    methodDesc2: "• Imitation (ST); Social-Emotional Understanding (HF)",
    methodDesc3: "• Emotional Response (ST); Emotional Expression and Regulation of Emotions (HF)",
    methodDesc4: "• Body Use",
    methodDesc5: "• Object Use (ST); Object Use in Play (HF)",
    methodDesc6: "• Adaptation to Change (ST); Adaptation to Change/Restricted Interests (HF)",
    methodDesc7: "• Visual Response",
    methodDesc8: "• Listening Response",
    methodDesc9: "• Taste, Smell, and Touch Response and Use",
    methodDesc10: "• Fear or Nervousness (ST); Fear or Anxiety (HF)",
    methodDesc11: "• Verbal Communication",
    methodDesc12: "• Nonverbal Communication",
    methodDesc13: "• Activity Level (ST); Thinking/Cognitive Integration Skills (HF)",
    methodDesc14: "• Level and Consistency of Intellectual Response",
    methodDesc15: "• General Impressions",
    evaluationResults: "",
    resultsDesc: "The parent or caregiver of the individual being assessed completes this unscored form. Its primary purpose is to give the clinician more information on which to base the CARS2-ST or CARS2-HF ratings. The questionnaire covers an individual’s early development; social, emotional, and communication skills; repetitive behaviors; play and routines; and unusual sensory interests.",
    advantage: "",
    advantageDesc1: "",
    advantageDesc2: "",
    advantageDesc3: "",
    advantageDesc4: "",
    advantageDesc5: "",
    qualification: "",
    qualificationDesc: "",
    address: "4F404 Building A, TechBay C & More, Wanchuang Road, Tangiawan Town, Hi-techZone,Zhuhai, Guangdong, China P.C., 519080",
}
Object.assign(langEn, commonEn, homeEn, consultEn, aboutEn, legalEn)
export default langEn;



// WEBPACK FOOTER //
// ./src/i18n/en.js